import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box, Button, Text } from '../../../../designSystem'
import ArrowLeft from '../../../../components/Images/ArrowLeft'
import WalletGraphic from '../../../../components/Images/WalletGraphic'
import { get } from '../../../../lib/api'
import WeekCalender from './BonusWeekCalender/WeekCalender'
import { handleEventLog } from '../../../../lib/utils'

const PostPublishUpperDiv = styled.div`
  max-width: 1024px;
  display: flex;
  margin: 8px auto 0;
  flex-direction: column;
  @media (max-width: 600px) {
    margin: 0;
  }
`
const BackBtnIcon = styled(ArrowLeft)`
  width: 24px;
  height: 24px;
`

const CongratsText = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  color: rgba(13, 21, 54, 0.8);
  margin-left: 40px;
  margin-top: 0px;
  @media (max-width: 600px) {
    font-size: 18px;
    margin-top: 1px;
    margin-left: 35px;
  }
`
const CashbackImgDiv = styled.div`
  background-image: url('/images/cashback_background_web.svg');
  width: 100%;
  height: 223px;
  margin: 4px 0;
  position: relative;
  @media (max-width: 600px) {
    background-image: url('/images/cashback_background_mobile.svg');
    height: 155px;
  }
`
const WalletGraphicIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`
const HR = styled.div`
  height: 1px;
  margin: 16px 10px 0;
  background-color: #e9e6e6;
`

const GirlBackBox = styled.div`
  background-image: url('/images/girl-writer.svg');
  width: 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  height: 217px;
  align-items: center;
  justify-content: center;
  @media (max-width: 600px) {
    background-image: none;
    height: unset;
    margin-bottom: 16px;
  }
`
const MobileGirlBackBox = styled.div`
  display: flex;
  align-items: center;
`
const MobileGirlBackBoxTxt = styled.span`
  font-size: 18px;
  text-align: center;
  color: rgba(13, 21, 54, 0.8);
`
const StreakBox = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 11px 6px 10px;
  border-radius: 4px;
  background-color: #e2f1fb;
  @media (max-width: 600px) {
    margin-top: 10px;
    font-size: 14px;
  }
`
const StreakTxt = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.43;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 14px;
  }
`
const StreakInfoTxt = styled.span`
  color: #799e22;
`
const StreakDescTxt = styled.div`
  font-size: 14px;
  line-height: 1.43;
  text-align: center;
  margin-top: 2px;
  color: rgba(13, 21, 54, 0.81);
  @media (max-width: 600px) {
    font-size: 12px;
  }
`

const PostPublishScreen = ({
  bookId,
  publishDate,
  handleBack,
  onAddChapter,
  showPostPublishData,
}) => {
  const { isUgcBook } = showPostPublishData
  const [dailyBonus, setDailyBonus] = useState(null)
  const isMobile = window.screen.width < 600
  const scheduledPublishDate = new Date(publishDate)
  const todaysDate = new Date()
  const isChapterPublishedToday =
    scheduledPublishDate.getDate() === todaysDate.getDate() &&
    scheduledPublishDate.getMonth() === todaysDate.getMonth() &&
    scheduledPublishDate.getFullYear() === todaysDate.getFullYear()
  useEffect(() => {
    window.scrollTo(0, 0)
    get(`/content_api/book.wbp_daily_incentive/${bookId}/?is_novel=1`).then((res) => {
      setDailyBonus(res)
    })
    handleEventLog("post_publish", "page_load", {
      entity_id: showPostPublishData.chapter_id || "",
      entity_type: 'chapter'
    })
    if('IntersectionObserver' in window){
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {   
            if (entry.isIntersecting) {
              handleEventLog('post_publish', 'impressions', {
                  module_name: entry.target.id,
                  entity_id: showPostPublishData.chapter_id || "",
                  entity_type: 'chapter'
              })
            }
          })
        }, {
          delay: 100,
          trackVisibility: true,
          threshold: 0.9,
        }
      )

      const elementsToObserve = document.getElementsByClassName('under_observation')
      for (let i=0; i<elementsToObserve.length; i++) {
        observer.observe(elementsToObserve[i])
      }
      return () => observer.disconnect()
    }
  }, [])

  const StreakIncentiveCalendar = () => (
    <>
      <StreakBox className='under_observation' id='streak'>
          <StreakTxt>
            {showPostPublishData.rem_streak_days === 0 ? (
              <>
                Publish regularly & Continue to enjoy the benefits of Streak
                Incentive!
              </>
            ) : (
              <>
                Publish{' '}
                <StreakInfoTxt>
                  <strong>
                    {showPostPublishData.rem_streak_days} more days
                  </strong>
                </StreakInfoTxt>{' '}
                to get{' '}
                <StreakInfoTxt>
                  <strong>Streak Incentive!</strong>
                </StreakInfoTxt>
              </>
            )}
          </StreakTxt>
          <StreakDescTxt>
            Increase incentive from{' '}
            <strong>{showPostPublishData.from_incentive_value}</strong> to{' '}
            <strong>{showPostPublishData.to_incentive_value}</strong>!
          </StreakDescTxt>
          {dailyBonus && (
            <WeekCalender
              wbpFirstOngoingDate={dailyBonus?.wbp_ongoing_date}
              incentives_data={dailyBonus?.incentives_data || null}
              isUgcBook={isUgcBook}
            />
          )}
      </StreakBox>
    </>
  )

  const CashbackBlock = () => (
    <CashbackImgDiv className='under_observation' id='hero_banner'>
        <WalletGraphicIcon>
          <WalletGraphic
            width={isMobile ? '150px' : '234px'}
            height={isMobile ? '112px' : '175px'}
          />
        </WalletGraphicIcon>
      </CashbackImgDiv>
  )

  return (
    <PostPublishUpperDiv>
      <Box p={16} backgroundColor="#fdfdfd">
        <div style={{ float: 'left' }} onClick={handleBack}>
          <BackBtnIcon />
        </div>
        <CongratsText>Congratulations!</CongratsText>
        {/* {isMobile && <CrossDark onClick={handleBack}/>} */}
      </Box>
      {showPostPublishData?.streak_incentive_awareness_variant === 'B' ? <StreakIncentiveCalendar />  : <CashbackBlock />}
      <Box
        display="flex"
        flexDirection="column"
        p={16}
        mb={44}
        backgroundColor="#fdfdfd"
      >
        {showPostPublishData?.streak_incentive_awareness_variant !== 'B' && 
        <Text style={{ textAlign: 'center' }} className='under_observation' id='reward_note'>
          {isChapterPublishedToday || !publishDate
            ? 'Rewards for the day will be credited to you post the editorial review in Income Tab'
            : `Rewards for the day will be credited to you post the editorial review on ${publishDate} in Income Tab given that the ${isUgcBook? 'series' :  `novel's`} engagement is good.`}
        </Text>}
        <HR />
        <GirlBackBox className='under_observation' id='next_chapter'>
          {!isMobile && (
            <Text variant="headingPrimary" fontSize={[20, 24]} mt={24}>
              Don’t keep your fans waiting!
            </Text>
          )}
          {isMobile && (
            <MobileGirlBackBox>
              <img src="/images/girl-writer-mobile.svg" alt=""/>
              <MobileGirlBackBoxTxt>
                Don’t keep your fans waiting!
              </MobileGirlBackBoxTxt>
            </MobileGirlBackBox>
          )}
          <Button mt={24} onClick={onAddChapter} fontSize={16}>
            Write Your Next Chapter Now!
          </Button>
        </GirlBackBox>
        {showPostPublishData?.streak_incentive_awareness_variant === 'B' ? 
          <>
            <CashbackBlock />
            <Text style={{ textAlign: 'center' }} p={16} className='under_observation' id='reward_note'>
            {isChapterPublishedToday || !publishDate
              ? 'Rewards for the day will be credited to you post the editorial review in Income Tab'
              : `Rewards for the day will be credited to you post the editorial review on ${publishDate} in Income Tab given that the ${isUgcBook? 'series' :  `novel's`} engagement is good.`}
            </Text> 
          </> : 
            <StreakIncentiveCalendar />
        }
      </Box>
    </PostPublishUpperDiv>
  )
}
export default PostPublishScreen
